export default __webpack_public_path__ + "static/media/01.43166270.jpg";